"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var Proto = /*#__PURE__*/function () {
  function Proto(_ref) {
    var proto = _ref.proto,
        packagePrefix = _ref.packagePrefix;
    (0, _classCallCheck2["default"])(this, Proto);
    this.cache = {};
    this.proto = proto;
    this.packagePrefix = packagePrefix;
  }

  (0, _createClass2["default"])(Proto, [{
    key: "getMessage",
    value: function getMessage(path) {
      if (this.cache[path]) return this.cache[path];

      var ret = _lodash["default"].get(this.proto, "".concat(this.packagePrefix, ".").concat(path), {});

      this.cache[path] = ret;
      return ret;
    }
  }]);
  return Proto;
}();

var _default = Proto;
exports["default"] = _default;